/* You Fly LA page kit (r10) — assets/yh-program.js
   Behaviour for the program-page sections (sections/yh-p-promo, -tiers, -calc, -bars, -timeline, -tabs, -ladder, -reviews,
   -guarantee, -earnings, -finance, -guide), loaded with defer after assets/yh-pages.js on page templates whose suffix starts
   with "yh-" (layout/theme.liquid). Each section carries data-yhpp="<name>"; every init runs in try/catch and the section
   gets .is-ready when done. Markup is complete server-side; without JavaScript everything is visible and the JS-only
   controls (.yhp-jsonly) are hidden. Theme editor: sections re-initialise on shopify:section:load.
   Offer deadlines are written in Los Angeles time and converted with the real America/Los_Angeles rules (Intl); every
   [data-offer-until] element on the page disappears the moment its deadline passes.
   Global: window.YHPP only. Never cancels clicks on booking / enroll / contact / tel links: the Enroll buttons carry
   /#enroll + data-pick + data-pkg and assets/yfla-book.js opens the enrollment pop-up. */
(function () {
'use strict';
if (window.YHPP) return;

const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
const MQ = { reduce: matchMedia('(prefers-reduced-motion: reduce)'), wide: matchMedia('(min-width: 960px)') };
const warn = (tag, e) => { if (window.console) console.warn('yh-program', tag, e); };
const money = (n) => (n < 0 ? '−' : '') + '$' + Math.round(Math.abs(n)).toLocaleString('en-US');
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const behavior = () => (MQ.reduce.matches ? 'auto' : 'smooth');

function onSwipe(el, cb) {
  let x0 = null, y0 = 0, t0 = 0;
  el.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); });
  el.addEventListener('pointerup', (e) => {
    if (x0 === null) return;
    const dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2 && Date.now() - t0 < 800) cb(dx < 0 ? 1 : -1);
  });
  el.addEventListener('pointercancel', () => { x0 = null; });
}

/* shared selection between Package Tiers, Cost Calculator and Hours Bars of the same data-group */
const Bus = {
  subs: {},
  on(g, id, fn) { if (!g) return; (this.subs[g] = this.subs[g] || []).push({ id: id, fn: fn }); },
  emit(g, i, from) { if (!g) return; (this.subs[g] || []).forEach((s) => { if (s.id !== from) { try { s.fn(i); } catch (e) { warn('bus', e); } } }); }
};
let uidN = 0;
const uid = () => 'yhpp' + (++uidN);

/* =====================================================================
   OFFER — Los Angeles deadlines, the countdown, and hiding every offer part when it passes
   ===================================================================== */
function tzOffset(ms) {
  const f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  const p = f.formatToParts(new Date(ms));
  const g = (t) => +((p.find((x) => x.type === t) || {}).value || 0);
  return Date.UTC(g('year'), g('month') - 1, g('day'), g('hour') % 24, g('minute'), g('second')) - Math.floor(ms / 1000) * 1000;
}
function laToUtc(str) {
  const m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?/.exec(String(str || '').trim());
  if (!m) return NaN;
  const wall = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, m[6] ? +m[6] : 59);
  try {
    let t = wall - tzOffset(wall);
    const o2 = tzOffset(t);
    if (wall - o2 !== t) t = wall - o2;
    return t;
  } catch (e) {
    const mo = +m[2];
    return wall + (mo > 3 && mo < 11 ? 7 : 8) * 3600000;
  }
}
const Offers = (function () {
  const list = [];
  let timer = 0;
  function expire(o) {
    o.done = true;
    const el = o.el;
    if (el.matches('[data-yhpp="offer"]')) {
      if (el.hasAttribute('data-offer-whole')) el.hidden = true;
      else $$('[data-offer-part]', el).forEach((p) => { p.hidden = true; });
      el.classList.add('is-over');
    } else el.hidden = true;
  }
  function paint(o, left) {
    const s = Math.floor(left / 1000);
    const v = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
    o.cells.forEach((c) => { const t = String(v[c.dataset.u]).padStart(2, '0'); if (c.textContent !== t) c.textContent = t; });
    if (o.cd) o.cd.setAttribute('aria-label', `${o.label}: ${v.d} days, ${v.h} hours, ${v.m} minutes`);
  }
  function tick() {
    const now = Date.now();
    let live = 0;
    list.forEach((o) => {
      if (o.done) return;
      const left = o.t - now;
      if (!(left > 0)) { expire(o); return; }
      live += 1;
      if (o.cells.length) paint(o, left);
    });
    if (!live && timer) { clearInterval(timer); timer = 0; }
  }
  function add(el) {
    if (el.dataset.offerWatch) return;
    el.dataset.offerWatch = '1';
    const t = laToUtc(el.getAttribute('data-offer-until'));
    if (isNaN(t)) return;
    const cd = el.matches('[data-yhpp="offer"]') ? $('.yhp-ofr__cd', el) : null;
    const o = { el: el, t: t, done: false, cd: cd, cells: cd ? $$('[data-u]', cd) : [], label: cd ? (cd.getAttribute('aria-label') || 'Offer Ends In') : '' };
    list.push(o);
    tick();
    if (!timer && list.some((x) => !x.done)) timer = setInterval(tick, 1000);
  }
  function scan(scope) { $$('[data-offer-until]', scope || document).forEach(add); }
  return { scan: scan, tick: tick, laToUtc: laToUtc };
})();
function initOffer(root) { Offers.scan(root.parentNode || document); }

/* =====================================================================
   PACKAGE TIERS — picker, card click, phone carousel starting on the middle card, dots, shared selection
   ===================================================================== */
function initTiers(root) {
  const me = uid(), group = root.dataset.group || '';
  const list = $('.yhp-tier__list', root), cards = $$('.yhp-tier__card', root);
  const picks = $$('.yhp-tier__pick [data-t]', root), dots = $$('.yhp-tier__dots [data-t]', root);
  if (!cards.length) return;
  let cur = clamp(+root.dataset.start || 0, 0, cards.length - 1), lockUntil = 0;
  const scrollable = () => list.scrollWidth > list.clientWidth + 4;
  function centerOn(i, smooth) {
    if (!scrollable()) return;
    const c = cards[i];
    const left = c.offsetLeft - (list.clientWidth - c.offsetWidth) / 2;
    lockUntil = Date.now() + (smooth ? 700 : 80);
    if (smooth && list.scrollTo) list.scrollTo({ left: left, behavior: behavior() }); else list.scrollLeft = left;
  }
  function paint(i) {
    cards.forEach((c, k) => c.classList.toggle('is-on', k === i));
    picks.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.t === i)));
    dots.forEach((b) => b.classList.toggle('is-on', +b.dataset.t === i));
  }
  function select(i, opts) {
    opts = opts || {};
    i = clamp(i, 0, cards.length - 1);
    const changed = i !== cur;
    cur = i; paint(i);
    if (opts.scroll) centerOn(i, true);
    if (changed || opts.force) Bus.emit(group, i, me);
  }
  picks.forEach((b) => b.addEventListener('click', () => select(+b.dataset.t, { scroll: true })));
  dots.forEach((b) => b.addEventListener('click', () => select(+b.dataset.t, { scroll: true })));
  cards.forEach((c, k) => c.addEventListener('click', (e) => { if (e.target.closest('a,button,input,label')) return; select(k, { scroll: true }); }));
  $$('.yhp-tier__calc[data-t]', root).forEach((a) => a.addEventListener('click', () => select(+a.dataset.t, { force: true })));
  let deb = 0;
  list.addEventListener('scroll', () => {
    clearTimeout(deb);
    deb = setTimeout(() => {
      if (Date.now() < lockUntil || !scrollable()) return;
      const mid = list.scrollLeft + list.clientWidth / 2;
      let best = cur, bd = Infinity;
      cards.forEach((c, k) => { const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = k; } });
      if (best !== cur) select(best);
    }, 110);
  }, { passive: true });
  Bus.on(group, me, (i) => { if (i !== cur) { cur = i; paint(i); centerOn(i, true); } });
  paint(cur);
  centerOn(cur, false);
  let lastWide = MQ.wide.matches;
  window.addEventListener('resize', () => { if (MQ.wide.matches !== lastWide) { lastWide = MQ.wide.matches; centerOn(cur, false); } });
}

/* =====================================================================
   COST CALCULATOR — package x upgrade hours; total = price + sum(hours x rate); hours together <= aircraft hours
   ===================================================================== */
function initCalc(root) {
  const me = uid(), group = root.dataset.group || '';
  const picks = $$('.yhp-calc__pick [data-t]', root);
  const ups = $$('.yhp-calc__up', root).map((el, k) => ({
    el: el, k: k, name: el.dataset.name || '', rate: +el.dataset.rate || 0,
    input: $('input', el), minus: $('[data-d="-1"]', el), plus: $('[data-d="1"]', el), sum: $('[data-f="sum"]', el), h: 0
  }));
  const tiers = picks.length ? picks.map((b) => ({ name: b.dataset.name, price: +b.dataset.price, ac: +b.dataset.ac })) : [];
  const f = (k) => $(`[data-f="${k}"]`, root);
  const lines = $$('.yhp-calc__line[data-line]', root);
  const enroll = $('.yhp-calc__enroll', root);
  const mix = { std: $('.yhp-calc__mix [data-seg="std"]', root), segs: ups.map((u) => $(`.yhp-calc__mix [data-seg="${u.k}"]`, root)) };
  if (!ups.length || !tiers.length) return;
  let t = clamp(+root.dataset.start || 0, 0, tiers.length - 1), liveT = 0;
  const used = (except) => ups.reduce((s, u) => s + (u === except ? 0 : u.h), 0);
  /* an edited stepper is capped at the room the others leave; a smaller package trims the most expensive upgrade first */
  function fit(edited) {
    const max = tiers[t].ac;
    ups.forEach((u) => { u.h = clamp(Math.round(u.h) || 0, 0, max); });
    if (edited) edited.h = Math.min(edited.h, Math.max(0, max - used(edited)));
    let over = used(null) - max;
    ups.slice().sort((a, b) => b.rate - a.rate).forEach((u) => { if (over > 0) { const r = Math.min(u.h, over); u.h -= r; over -= r; } });
  }
  function render(announce) {
    const T = tiers[t], max = T.ac;
    let total = T.price, pkg = `${T.name} — ${money(T.price)}`;
    ups.forEach((u) => {
      const room = max - used(u);
      if (u.input) { u.input.max = String(room); if (document.activeElement !== u.input || +u.input.value !== u.h) u.input.value = String(u.h); }
      if (u.minus) u.minus.disabled = u.h <= 0;
      if (u.plus) u.plus.disabled = u.h >= room;
      const add = u.h * u.rate;
      total += add;
      if (u.sum) u.sum.innerHTML = `${u.h} hrs × ${money(u.rate)} = <b>${money(add)}</b>`;
      const ln = lines[u.k];
      if (ln) { $('[data-f="h"]', ln).textContent = String(u.h); $('[data-f="p"]', ln).textContent = '+' + money(add); }
      if (u.h) pkg += ` + ${u.h} hrs ${u.name} (+${money(add)})`;
    });
    if (ups.some((u) => u.h)) pkg += ` = ${money(total)}`;
    f('pkg').textContent = `${T.name} Package`;
    f('pkgp').textContent = money(T.price);
    f('tot').textContent = money(total);
    const std = max - used(null);
    const parts = [`${max} aircraft hours`];
    if (ups.some((u) => u.h)) parts.push(`${std} at the standard rate`, ...ups.filter((u) => u.h).map((u) => `${u.h} ${u.name}`));
    else parts.push('all at the standard rate');
    f('mix').textContent = parts[0] + ': ' + parts.slice(1).join(' · ');
    if (mix.std) mix.std.style.width = (max ? (std / max) * 100 : 100).toFixed(2) + '%';
    mix.segs.forEach((s, k) => { if (s) s.style.width = (max ? (ups[k].h / max) * 100 : 0).toFixed(2) + '%'; });
    picks.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.t === t)));
    if (enroll) { enroll.setAttribute('data-pkg', (root.dataset.program ? root.dataset.program + ' · ' : '') + pkg); }
    if (announce) { clearTimeout(liveT); liveT = setTimeout(() => { f('live').textContent = `${T.name} with upgrades: total ${money(total)}`; }, 450); }
  }
  function setTier(i, emit) { t = clamp(i, 0, tiers.length - 1); fit(); render(true); if (emit) Bus.emit(group, t, me); }
  picks.forEach((b) => b.addEventListener('click', () => setTier(+b.dataset.t, true)));
  ups.forEach((u) => {
    const bump = (d) => { u.h += d; fit(u); render(true); };
    if (u.minus) u.minus.addEventListener('click', () => bump(-1));
    if (u.plus) u.plus.addEventListener('click', () => bump(1));
    if (u.input) {
      u.input.addEventListener('input', () => { if (u.input.value === '') return; u.h = parseInt(u.input.value, 10) || 0; fit(u); render(true); });
      u.input.addEventListener('change', () => { u.h = parseInt(u.input.value, 10) || 0; fit(u); render(true); u.input.value = String(u.h); });
      u.input.addEventListener('blur', () => { u.input.value = String(u.h); });
    }
  });
  Bus.on(group, me, (i) => { if (i !== t) setTier(i, false); });
  fit(); render(false);
}

/* =====================================================================
   HOURS BARS — one scale; switching packages morphs the same rows (or swaps sets when the rows differ)
   ===================================================================== */
function initBars(root) {
  const me = uid(), group = root.dataset.group || '';
  const sets = $$('.yhp-bars__set', root), picks = $$('.yhp-bars__pick [data-t]', root);
  if (sets.length < 2) return;
  const scale = +root.dataset.scale || 1, unit = root.dataset.unit || 'hrs';
  const data = sets.map((s) => ({ name: ($('.yhp-bars__n', s) || {}).textContent || '', sub: ($('.yhp-bars__sub', s) || {}).textContent || '', rows: $$('.yhp-bars__row', s).map((r) => ({ k: r.dataset.k, v: +r.dataset.v })) }));
  const keys = (d) => d.rows.map((r) => r.k).join('|');
  const morph = data.every((d) => keys(d) === keys(data[0]));
  let t = clamp(+root.dataset.start || 0, 0, sets.length - 1);
  const host = sets[t];
  function set(i, emit) {
    t = clamp(i, 0, sets.length - 1);
    picks.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.t === t)));
    if (morph) {
      const d = data[t];
      const n = $('.yhp-bars__n', host), sb = $('.yhp-bars__sub', host);
      if (n) n.textContent = d.name;
      if (sb) sb.textContent = d.sub;
      $$('.yhp-bars__row', host).forEach((r, k) => {
        const v = d.rows[k].v;
        r.dataset.v = String(v);
        $('.yhp-bars__v', r).innerHTML = `<b>${v}</b> ${unit}`;
        $('.yhp-bars__track i', r).style.width = ((v / scale) * 100).toFixed(1) + '%';
      });
    } else sets.forEach((s, k) => s.classList.toggle('is-on', k === t));
    if (emit) Bus.emit(group, t, me);
  }
  picks.forEach((b) => b.addEventListener('click', () => set(+b.dataset.t, true)));
  Bus.on(group, me, (i) => { if (i !== t) set(i, false); });
}

/* =====================================================================
   TIMELINE — rail of stops (tabs pattern), progress line, Previous / Next, arrow keys, swipe
   ===================================================================== */
function initTimeline(root) {
  const btns = $$('.yhp-tml__b', root), stops = $$('.yhp-tml__stop', root), n = stops.length;
  if (n < 2 || btns.length !== n) return;
  const prog = $('.yhp-tml__prog', root), ct = $('[data-ct]', root);
  stops.forEach((s, i) => { s.setAttribute('role', 'tabpanel'); s.setAttribute('aria-labelledby', btns[i].id); });
  let i = 0;
  function set(k, focus) {
    i = clamp(k, 0, n - 1);
    btns.forEach((b, j) => { b.setAttribute('aria-selected', String(j === i)); b.tabIndex = j === i ? 0 : -1; b.classList.toggle('is-done', j <= i); });
    stops.forEach((s, j) => s.classList.toggle('is-on', j === i));
    if (prog) prog.style.width = ((i / (n - 1)) * 100).toFixed(2) + '%';
    if (ct) ct.textContent = String(i + 1);
    $$('[data-go]', root).forEach((b) => { b.disabled = (+b.dataset.go < 0 && i === 0) || (+b.dataset.go > 0 && i === n - 1); });
    if (focus) btns[i].focus();
  }
  btns.forEach((b, j) => {
    b.addEventListener('click', () => set(j));
    b.addEventListener('keydown', (e) => {
      let k = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') k = Math.min(n - 1, i + 1);
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') k = Math.max(0, i - 1);
      else if (e.key === 'Home') k = 0;
      else if (e.key === 'End') k = n - 1;
      if (k !== null) { e.preventDefault(); set(k, true); }
    });
  });
  $$('[data-go]', root).forEach((b) => b.addEventListener('click', () => set(i + +b.dataset.go)));
  const lst = $('.yhp-tml__list', root);
  if (lst) onSwipe(lst, (d) => set(i + d));
  set(0);
}

/* =====================================================================
   INFO TABS — WAI-ARIA tabs
   ===================================================================== */
function initInfoTabs(root) {
  const tabs = $$('[role="tab"]', root), panels = $$('.yhp-itab__p', root);
  if (tabs.length < 2 || tabs.length !== panels.length) return;
  panels.forEach((p, k) => { p.setAttribute('role', 'tabpanel'); p.setAttribute('aria-labelledby', tabs[k].id); p.tabIndex = 0; });
  const set = (i, focus) => {
    tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
    panels.forEach((p, k) => p.classList.toggle('is-on', k === i));
    if (focus) tabs[i].focus();
    const bar = tabs[i].parentNode;
    if (bar.scrollWidth > bar.clientWidth) bar.scrollLeft = Math.max(0, tabs[i].offsetLeft - 16);
  };
  tabs.forEach((t, k) => {
    t.addEventListener('click', () => set(k));
    t.addEventListener('keydown', (e) => {
      const n = tabs.length;
      let j = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (k + 1) % n;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (k - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j !== null) { e.preventDefault(); set(j, true); }
    });
  });
}

/* =====================================================================
   NEXT STEPS — tap a step: the path up to it and the running total of published course prices
   ===================================================================== */
function initLadder(root) {
  const steps = $$('.yhp-lad__step[data-amt]', root);
  const sels = $$('.yhp-lad__sel', root);
  const sumEl = $('[data-f="sum"]', root), pathEl = $('[data-f="path"]', root);
  if (!steps.length) return;
  const all = $$('.yhp-lad__step', root);
  const lastChain = steps[steps.length - 1];
  if (lastChain) lastChain.classList.add('is-last');
  let end = -1;
  function set(k) {
    end = k;
    let sum = 0;
    const names = [];
    steps.forEach((s, j) => {
      const on = j <= k;
      s.classList.toggle('is-path', on);
      s.classList.toggle('is-end', j === k);
      if (on) { sum += +s.dataset.amt || 0; names.push(s.dataset.title); }
    });
    sels.forEach((b) => b.setAttribute('aria-pressed', String(steps.indexOf(b.closest('.yhp-lad__step')) === k)));
    steps.forEach((s2, j) => { const r = $('[data-f="run"]', s2); if (r) r.textContent = j === k ? money(sum) : ''; });
    if (sumEl) sumEl.textContent = money(sum);
    if (pathEl) pathEl.textContent = names.length ? names.join(' → ') : (root.dataset.empty || 'Tap “Add Up To Here” on any step');
  }
  sels.forEach((b) => b.addEventListener('click', () => { const k = steps.indexOf(b.closest('.yhp-lad__step')); set(k === end ? -1 : k); }));
  void all;
  const st = +root.dataset.start;
  set(st >= 0 && st < steps.length ? st : -1);
}

/* =====================================================================
   GOOGLE REVIEWS — self-scrolling strip (a real scroller), pause on hover / focus / touch / Read More / button,
   reduced motion = static scroller with arrows; Read More only where the text is clamped
   ===================================================================== */
function initReviews(root) {
  const vp = $('.yhp-rev__vp', root), track = $('.yhp-rev__track', root);
  if (!vp || !track) return;
  const cards = $$('.yhp-rev__card', track);
  const pp = $('.yhp-rev__pp', root);
  const reasons = new Set();
  const speed = clamp(+root.dataset.speed || 28, 6, 90);
  const auto = !MQ.reduce.matches && cards.length > 1;
  let pos = 0, half = 0, prevT = 0, raf = 0;
  const step = () => (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : 320);
  /* Read More */
  function clampCheck() {
    cards.forEach((c) => {
      const tx = $('.yhp-rev__t', c), b = $('.yhp-rev__more', c);
      if (!tx || !b || c.classList.contains('is-open')) return;
      b.hidden = !(tx.scrollHeight > tx.clientHeight + 2);
    });
  }
  cards.forEach((c, k) => {
    const b = $('.yhp-rev__more', c);
    if (!b) return;
    b.dataset.more = b.textContent.trim();
    b.addEventListener('click', () => {
      const open = !c.classList.contains('is-open');
      c.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', String(open));
      b.textContent = open ? 'Read Less' : b.dataset.more;
      const twin = track.querySelectorAll('.yhp-rev__card.is-clone')[k];
      if (twin) twin.classList.toggle('is-open', open);
      if (open) reasons.add('read' + k); else reasons.delete('read' + k);
      syncBtn();
    });
  });
  function syncBtn() {
    if (!pp) return;
    const paused = reasons.has('btn');
    pp.setAttribute('aria-pressed', String(paused));
    pp.textContent = paused ? pp.dataset.play : pp.dataset.pause;
  }
  function nav(d) {
    if (auto) { reasons.add('nav'); clearTimeout(nav.t); nav.t = setTimeout(() => { reasons.delete('nav'); pos = vp.scrollLeft; }, 900); }
    if (auto && d < 0 && vp.scrollLeft < step()) { vp.scrollLeft += half; pos = vp.scrollLeft; }
    vp.scrollBy({ left: d * step(), behavior: behavior() });
  }
  $$('[data-go]', root).forEach((b) => b.addEventListener('click', () => nav(+b.dataset.go)));
  if (!auto) {
    root.classList.add('is-still');
    clampCheck();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(clampCheck);
    return;
  }
  root.classList.add('is-auto');
  cards.forEach((c) => {
    const k = c.cloneNode(true);
    k.classList.add('is-clone');
    k.setAttribute('aria-hidden', 'true');
    k.inert = true;
    $$('[id]', k).forEach((x) => x.removeAttribute('id'));
    $$('button,a', k).forEach((x) => { x.tabIndex = -1; });
    track.appendChild(k);
  });
  const measure = () => { const first = track.querySelector('.yhp-rev__card.is-clone'); half = first ? first.offsetLeft - cards[0].offsetLeft : 0; };
  measure();
  clampCheck();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { measure(); clampCheck(); });
  window.addEventListener('resize', () => { measure(); clampCheck(); });
  vp.addEventListener('mouseenter', () => reasons.add('hover'));
  vp.addEventListener('mouseleave', () => { reasons.delete('hover'); pos = vp.scrollLeft; });
  vp.addEventListener('focusin', () => reasons.add('focus'));
  vp.addEventListener('focusout', (e) => { if (!vp.contains(e.relatedTarget)) { reasons.delete('focus'); pos = vp.scrollLeft; } });
  vp.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') { reasons.add('touch'); clearTimeout(vp.tt); } });
  const release = (e) => { if (e.pointerType !== 'mouse') { clearTimeout(vp.tt); vp.tt = setTimeout(() => { reasons.delete('touch'); pos = vp.scrollLeft; }, 2500); } };
  vp.addEventListener('pointerup', release);
  vp.addEventListener('pointercancel', release);
  vp.addEventListener('scroll', () => {
    if (Math.abs(vp.scrollLeft - Math.round(pos)) > 3) pos = vp.scrollLeft;
    if (half && vp.scrollLeft >= half + 2 && !reasons.has('nav')) { vp.scrollLeft -= half; pos = vp.scrollLeft; }
  }, { passive: true });
  if (pp) pp.addEventListener('click', () => { if (reasons.has('btn')) reasons.delete('btn'); else reasons.add('btn'); pos = vp.scrollLeft; syncBtn(); });
  if ('IntersectionObserver' in window) new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) reasons.delete('off'); else reasons.add('off'); })).observe(vp);
  function frame(ts) {
    const dt = prevT ? Math.min(100, ts - prevT) : 0;
    prevT = ts;
    if (!reasons.size && half > 0) {
      pos += (speed * dt) / 1000;
      if (pos >= half) pos -= half;
      vp.scrollLeft = pos;
    }
    raf = requestAnimationFrame(frame);
  }
  raf = requestAnimationFrame(frame);
  root.YHPPstop = () => cancelAnimationFrame(raf);
  syncBtn();
}

/* =====================================================================
   DISCLOSE — "How It Works" buttons (Guarantees)
   ===================================================================== */
function initDisclose(root) {
  $$('button[aria-controls]', root).forEach((b) => {
    const d = document.getElementById(b.getAttribute('aria-controls'));
    if (!d) return;
    b.addEventListener('click', () => { const on = b.getAttribute('aria-expanded') !== 'true'; b.setAttribute('aria-expanded', String(on)); d.classList.toggle('is-open', on); });
  });
}

/* =====================================================================
   EARNINGS CHART — a column per figure; the detail line follows the selected column
   ===================================================================== */
function initEarnings(root) {
  const cols = $$('.yhp-earn__col', root), btns = $$('.yhp-earn__b', root), ds = $$('.yhp-earn__d', root);
  if (!btns.length) return;
  const set = (i) => {
    cols.forEach((c, k) => c.classList.toggle('is-on', k === i));
    btns.forEach((b, k) => b.setAttribute('aria-pressed', String(k === i)));
    ds.forEach((d, k) => d.classList.toggle('is-on', k === i));
  };
  btns.forEach((b, k) => {
    b.addEventListener('click', () => set(k));
    b.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); const j = clamp(k + (e.key === 'ArrowRight' ? 1 : -1), 0, btns.length - 1); set(j); btns[j].focus(); }
    });
  });
  set(clamp(+root.dataset.start || 0, 0, btns.length - 1));
}

/* =====================================================================
   FINANCING — published terms only; loan = standard amortization at an ILLUSTRATIVE rate; direct = balance / months
   ===================================================================== */
function initFinance(root) {
  const price = +root.dataset.price || 0;
  const down = $('input[type="range"][id$="-down"]', root), months = $('input[type="range"][id$="-mo"]', root);
  const modeB = $$('[data-mode]', root), termB = $$('[data-term]', root), rateB = $$('[data-rate]', root);
  const f = (k) => $(`[data-f="${k}"]`, root);
  if (!down || !price) return;
  const st = { mode: 'loan', term: +root.dataset.term || 10, rate: root.dataset.rate === '' ? NaN : +root.dataset.rate, months: +root.dataset.months || 12 };
  if (!rateB.length) st.rate = NaN;
  function calc() {
    const d = clamp(+down.value || 0, 0, price);
    const bal = price - d;
    let monthly = null, per = '', repaid = null;
    if (st.mode === 'direct') {
      const m = months ? +months.value : st.months;
      monthly = bal / m; per = `/ month for ${m} month${m === 1 ? '' : 's'}, interest-free`;
    } else if (!isNaN(st.rate)) {
      const r = st.rate / 100 / 12, n = st.term * 12;
      monthly = r ? (bal * r) / (1 - Math.pow(1 + r, -n)) : bal / n;
      repaid = monthly * n; per = `/ month for ${st.term} years at an illustrative ${st.rate}%`;
    } else per = 'set by the lender';
    f('down').textContent = money(d); f('down2').textContent = money(d);
    f('bal').textContent = money(bal);
    f('balk').textContent = st.mode === 'direct' ? 'Balance paid to You Fly LA' : 'Amount financed';
    f('monthly').textContent = monthly === null ? '—' : money(monthly);
    f('per').textContent = per;
    if (f('repaid')) f('repaid').textContent = repaid === null ? '—' : money(repaid);
    if (months && f('months')) f('months').textContent = months.value;
    $$('[data-for]', root).forEach((el) => { el.hidden = el.dataset.for !== st.mode; });
    modeB.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mode === st.mode)));
    termB.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.term === st.term)));
    rateB.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.rate === st.rate)));
  }
  modeB.forEach((b) => b.addEventListener('click', () => { st.mode = b.dataset.mode; calc(); }));
  termB.forEach((b) => b.addEventListener('click', () => { st.term = +b.dataset.term; calc(); }));
  rateB.forEach((b) => b.addEventListener('click', () => { st.rate = +b.dataset.rate; calc(); }));
  down.addEventListener('input', calc);
  if (months) months.addEventListener('input', calc);
  calc();
}

/* =====================================================================
   FULL GUIDE — open / close the page's own article; chips jump to its sections
   ===================================================================== */
function initGuide(root) {
  const art = $('.yhp-guide__art', root), btn = $('.yhp-guide__b', root), chips = $('[data-chips]', root);
  if (!art || !btn) return;
  const label = $('span', btn);
  function open(on, target) {
    root.classList.toggle('is-open', on);
    btn.setAttribute('aria-expanded', String(on));
    if (label) label.textContent = on ? btn.dataset.close : btn.dataset.open;
    if (on && target) requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: behavior() }));
    if (!on) root.scrollIntoView({ block: 'start', behavior: 'auto' });
  }
  btn.addEventListener('click', () => open(btn.getAttribute('aria-expanded') !== 'true'));
  if (chips) {
    $$('h2', art).slice(0, 10).forEach((h, k) => {
      if (!h.id) h.id = (root.id || 'guide') + '-s' + (k + 1);
      const c = document.createElement('button');
      c.type = 'button'; c.className = 'yh-chip';
      c.textContent = h.textContent.trim().replace(/\s+/g, ' ').replace(/\.$/, '');
      c.addEventListener('click', () => open(true, h));
      chips.appendChild(c);
    });
  }
}

/* =====================================================================
   INIT
   ===================================================================== */
const INIT = { offer: initOffer, tiers: initTiers, calc: initCalc, bars: initBars, timeline: initTimeline, infotabs: initInfoTabs, ladder: initLadder,
  reviews: initReviews, disclose: initDisclose, earnings: initEarnings, finance: initFinance, guide: initGuide };
function initIn(scope) {
  $$('[data-yhpp]', scope || document).forEach((el) => {
    if (el.dataset.yhppInit) return;
    el.dataset.yhppInit = '1';
    const fn = INIT[el.dataset.yhpp];
    if (fn) { try { fn(el); } catch (e) { warn(el.dataset.yhpp, e); } }
    el.classList.add('is-ready');
  });
  try { Offers.scan(scope || document); } catch (e) { warn('offers', e); }
}
initIn(document);
document.addEventListener('shopify:section:load', (e) => initIn(e.target));
window.YHPP = { version: 'r10', init: initIn, offers: Offers, bus: Bus };
})();
